export const validateFromToWeek = scopedFormData => {
  const from = scopedFormData?.fromWeek;
  const to = scopedFormData?.toWeek;

  if (!from || !to) return;
  if (to < from) return "Крайна седмица не може да е преди начална";
};

export const validateTimeStart = scopedFormData => {
  const start = scopedFormData?.startTime;
  const end = scopedFormData?.endTime;

  if (!start) return "Задължително";
  if (start && end && start >= end) return "Начален час трябва да е преди краен";
};

export const validateTimeEnd = scopedFormData => {
  const start = scopedFormData?.startTime;
  const end = scopedFormData?.endTime;

  if (!end) return "Задължително";
  if (start && end && start >= end) return "Краен час трябва да е след начален";
};
